const main = () => {
    // PC版
    document.querySelectorAll('[data-footer-rail-trigger]').forEach(trigger => {
        trigger.addEventListener('click', () => {
            const item = trigger.closest('.l-footer-search__rail-item');
            if (!item) return;
            item.toggleAttribute('data-is-open');
        });
    });

    // SP版
    document.querySelectorAll('[data-footer-rail-trigger-sp]').forEach(trigger => {
        trigger.addEventListener('click', () => {
            const item = trigger.closest('.l-footer-search-sp__rail-item');
            if (!item) return;
            item.toggleAttribute('data-is-open');
        });
    });
};

export default main;
